import React from 'react';

import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { AssetItem } from '../../api/api-types/assets';

import { getPriorityIcons } from './PriorityIcons';

interface PriorityLabelProps extends BoxProps {
  priority?: AssetItem['priority'];
}

const PriorityLabel: React.FC<PriorityLabelProps> = ({
  priority,
  ...props
}) => {
  return (
    <PriorityBox
      {...props}
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '60%',
        ...props.sx,
      }}>
      {priority?.id && getPriorityIcons(priority?.id)}
      {priority?.name}
    </PriorityBox>
  );
};

const PriorityBox = styled(Box)({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '60%',
});

export default PriorityLabel;
